var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "instagram_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#instagram_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.666 12.124c-4.092 0-7.483 3.333-7.483 7.484a7.461 7.461 0 0 0 7.483 7.484c4.152 0 7.484-3.391 7.484-7.484s-3.39-7.484-7.483-7.484Zm0 12.278c-2.63 0-4.794-2.163-4.794-4.794s2.163-4.794 4.794-4.794c2.632 0 4.795 2.163 4.795 4.794s-2.163 4.794-4.794 4.794ZM27.443 13.644a1.696 1.696 0 1 0 0-3.39 1.696 1.696 0 0 0 0 3.39Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.828 7.564c-1.52-1.579-3.684-2.397-6.14-2.397H13.645c-5.086 0-8.477 3.39-8.477 8.477V25.63c0 2.514.818 4.678 2.455 6.256 1.579 1.52 3.684 2.28 6.08 2.28H25.63c2.514 0 4.62-.818 6.14-2.28 1.578-1.52 2.396-3.683 2.396-6.197V13.644c0-2.455-.818-4.56-2.338-6.08Zm-.234 18.125c0 1.812-.643 3.274-1.696 4.268-1.052.994-2.514 1.52-4.268 1.52H13.703c-1.754 0-3.216-.526-4.268-1.52-1.053-1.053-1.579-2.514-1.579-4.327V13.644c0-1.754.526-3.215 1.579-4.268.994-.994 2.514-1.52 4.268-1.52h12.044c1.754 0 3.216.526 4.268 1.579.994 1.052 1.579 2.514 1.579 4.21v12.044Z"
}))));
export default SvgInstagram;